import { FC } from 'react';
import { AlertMessageType } from 'basics/enums/maya.enums';
import AlertBanner from 'components/AlertBanner/AlertBanner';
import GridList from 'components/GridList/GridList';
import MayaLayout from 'components/MayaLayout';
import useCepTrashedList from 'routes/AuthenticatedApp/CepTrashedList/CepTrashedList.hook';
import Box from 'yoda-ui/components/Box';
import TextYoda from 'yoda-ui/components/Form/TextYoda';
import { useYodaCreateForm, YodaFormProvider } from 'yoda-ui/yodaForm';

const CepTrashedList: FC = () => {
  const { providerFields } = useYodaCreateForm();

  const {
    cepListColumnConfig,
    cepLoading,
    cepTitleFieldConfig,
    debouncedHandleChangeCepSearch,
    getFilteredRows,
    menuCustomerEngagementPlanningLabel,
    onPageChange,
    onPageSizeChange,
    rowCountState,
  } = useCepTrashedList();

  return (
    <MayaLayout>
      <AlertBanner type={ AlertMessageType.VeevaFatalErrorAlert } />
      <GridList
        loading={ cepLoading }
        getRowId={ (row) => row._id }
        title={ menuCustomerEngagementPlanningLabel }
        columnConfig={ cepListColumnConfig }
        rows={ getFilteredRows() }
        onPageChange={ onPageChange }
        onPageSizeChange={ onPageSizeChange }
        rowCountState={ rowCountState }
        customFilters={
          (
            <YodaFormProvider { ...providerFields }>
              <Box>
                <TextYoda
                  onChange={ debouncedHandleChangeCepSearch }
                  { ...cepTitleFieldConfig } />
              </Box>
            </YodaFormProvider>
          )
        }
        disableColumnMenu={ true }
      />
    </MayaLayout>
  );
};

export default CepTrashedList;
